export interface Account {
  id: string;
  label: string;
  color: string;
  provider?: 'claude' | 'codex' | 'gemini';
  house?: 'dev' | 'partner';
  accessNumber?: number;
}

export interface Project {
  id: string;
  name: string;
  workDir: string;
  location?: 'remote' | 'local';
  lastOpened: string;
}

// Mirrors server/routes/mission.ts UNASSIGNED_PROJECT_ID/NAME — sessions whose
// working directory matches no registered project (dead one-shot delegations,
// ad-hoc CLI usage). The id crosses the API boundary, so both sides must agree;
// kept in sync manually since server/ and src/ don't share a module.
export const UNASSIGNED_PROJECT_ID = '__unassigned__';
export const UNASSIGNED_PROJECT_NAME = 'Kein Workspace';

export interface PanelConfig {
  type: 'cui' | 'preview' | 'browser';
  accountId?: string;
  url?: string;
  watchPath?: string;
}

// Build-time generated from {claudeUserHome}/.claude/accounts/registry.json
// by scripts/generate-accounts.cjs (runs as `prebuild` script). Each
// deployment (dev / partner) bakes in its own real account list at build
// time — no hardcoded names that drift between environments.
import { GENERATED_ACCOUNTS } from './accounts-generated';
import { accountIdentity } from '../../shared/account-identity';
export const ACCOUNTS: Account[] = GENERATED_ACCOUNTS.map(account => ({
  ...account, label: accountIdentity(account.id, account.provider, account).label,
}));
export function accountAccessLabel(id?: string): string {
  return ACCOUNTS.find(account => account.id === id)?.label || accountIdentity(id || '').qualifiedLabel;
}

export function accountAccessShortLabel(id?: string): string {
  return accountAccessLabel(id).replace('Partner · ', 'P ').replace('Dev · ', 'D ').replace('KI-Zugang ', 'KI ').replace('Codex-Zugang ', 'CX ').replace('Gemini-Zugang ', 'GM ');
}

export function accountAssistantLabel(id?: string): string {
  const provider = ACCOUNTS.find(a => a.id === id)?.provider;
  return provider === 'codex' ? 'Codex' : provider === 'gemini' || id === 'gemini' ? 'Gemini' : 'Claude';
}

export type CuiState = 'idle' | 'processing' | 'done';
export type CuiStates = Record<string, CuiState>;
